// src/views/Users/Customers/Customers.jsx
import { useState, useEffect, useRef } from "react";
import { employeeConstants, modeConstants } from "../../../constants";
import { useDispatch, useSelector } from "react-redux";
import ActionsDataTable from "../../../shared/ActionsDataTable";
import { employeeActions, userActions } from "../../../redux/actions";
import { getUserData, SCREENS_IDS } from "../../../system";
import ViewAttendanceSessionsModal from "../../../shared/ViewAttendancePerDateModal";
import { success } from "../../../redux/actions/utilities";
import Timer from "../../../shared/Timer";
import EditAttendanceSessionModal from "../../../shared/EditAttendanceSessionModal";
import ViewAttendancePerDateModal from "../../../shared/ViewAttendancePerDateModal";

export default function Attendance() {
  const initialGridState = {
    column: "",
    type: "",
    search: null,
    filters: [],
  };

  const dispatch = useDispatch();
  const sortingInProgressRef = useRef(false);
  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(initialGridState.pageNumber);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState(modeConstants.ADD_MODE);
  // modal + row state
  const [rowData, setRowData] = useState([]);
  const [viewModal, setShowViewModal] = useState(false);

    const allData = useSelector((s) => s.employeeReducer.data);
  
  // filters aligned to table fields
  const filterColumns = [];

  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "100px",
    },
    {
      id: "name",
      name: "Name",
      selector: (row) => row.fullName,
      sortable: true,
      cell: (row) => (
        <div className="d-flex align-items-center">
          <span>{row.fullName}</span>
        </div>
      ),
    },
    {
      name: "Actions",
      sortable: false,
      width: "170px",
      cell: (row) => (
        <div
          className="d-flex align-items-center gap-2"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            className="btn btn-sm btn-outline-success"
            title="View"
            aria-label="View"
            onClick={() => {
              getRowData(row);
              setShowViewModal(true);
            }}
          >
            <i className="bi bi-eye" />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const getRowData = (row) => {
      dispatch(success(row.user_id, employeeConstants.EMPLOYEE_USER_ID));
      dispatch(success(row.id, employeeConstants.EMPLOYEE_ID));
      dispatch(employeeActions.getAllEmployeeAttendanceById(row.user_id));
  };
  const onSort = (sortedColumn, sortDirection) => {
    sortingInProgressRef.current = true;
    const columnDirection = sortDirection ? sortDirection.toUpperCase() : null;
    setDefaultPage(gridState.pageNumber);
    setGridState((prevState) => ({
      ...prevState,
      orderBy:
        columnDirection !== null ? `${sortedColumn.id} ${columnDirection}` : "",
    }));
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  const getAll = () => {
      dispatch(employeeActions.getAllEmployee(gridState));
  };

  useEffect(() => {
    if (allData !== null) {
      setRowData(allData);
    }
    // eslint-disable-next-line
  }, [allData]);

  useEffect(() => {
    getAll();
    sortingInProgressRef.current = false;
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    getAll();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <ViewAttendancePerDateModal
        show={viewModal}
        onHide={() => setShowViewModal(false)}
      />
      {/* optional place for Add button or filters if needed */}
      <ActionsDataTable
        columns={columns}
        filterColumns={filterColumns}
        data={rowData}
        pagination
        highlightOnHover
        striped
        responsive
        persistTableHead
        selectableRows
        selectableRowsHighlight
        selectableRowsVisibleOnly
        paginationServer={false}
        onSort={onSort}
        gridState={gridState}
        paginationTotalRows={rowData?.length}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        paginationDefaultPage={defaultPage}
        paginationResetDefaultPage
        setGridState={setGridState}
        setShowModal={setShowModal}
        setMode={setMode}
        allowToolbar={false}
        allowFilters={false}
      />
    </>
  );
}
